module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (155).4af2cd98.jpg";